import { ConfirmDrawer } from 'hooks/useConfirmDrawer'
import { Drawer } from 'components/Drawer'
import { Button } from 'blaze-ui/Button'
import Styles from 'components/ConfirmDeleteDrawer/ConfirmDeleteDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Heading } from 'blaze-ui/Heading/Heading'
import X02 from 'blaze-ui/icons/16/X02'

interface Props extends ConfirmDrawer {
  msg: string
  confirmText?: string
}

export const ConfirmDeleteDrawer = ({
  onCancel,
  onConfirm,
  onPressOutside,
  msg,
  confirmText = 'Confirm',
  ...props
}: Props) => (
  <Drawer.Root {...props}>
    <Drawer.Portal>
      <Drawer.Content>
        <Drawer.InnerContent>
          <Drawer.Top>
            <div />
            <Drawer.Title asChild>
              <Heading level={5}>Are you sure?</Heading>
            </Drawer.Title>
            <Drawer.Close variant="editor" icon={X02} position="right" label="" />
          </Drawer.Top>
          <Drawer.Container>
            <div className={Styles.content}>
              <Text>{msg}</Text>
              <div className={Styles.buttons}>
                <Button fullWidth onPress={onConfirm} size="xl" variant="primary">
                  {confirmText}
                </Button>
              </div>
            </div>
          </Drawer.Container>
        </Drawer.InnerContent>
      </Drawer.Content>
      <Drawer.Overlay />
    </Drawer.Portal>
  </Drawer.Root>
)
